import React from 'react';
import { Button, Col, Label, Row } from 'reactstrap';
import { showYesOrNoLabel, triggerFileDownloadByUrl } from '../../../../../../../../helper';

const KysTwoView = (props) => {
    let { kys2Data, viewDataFromSupplier } = props;

    return (
        <div className='hl-kys-two-view'>
            <Row
                className="non-registered-supplier-details-right text-left"
                gutter={[20, 24]}
            >
                <Col sm={24} md={6}>
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <h3 className="sd-common-heading">
                                KYS 2 details
                            </h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Supplier Category</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.SupplierCategoryName ? kys2Data?.SupplierCategoryName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Payment Terms</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.PaymentTermsName ? kys2Data?.PaymentTermsName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Grouping Key</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.GroupingKeyName ? kys2Data?.GroupingKeyName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Havells Business Contribution</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.HavellsBusinessContribution ? `${kys2Data?.HavellsBusinessContribution} %` : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Company Code</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.CompanyCodeName ? kys2Data?.CompanyCodeName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Order Currency</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.PaymentCurrencyName ? kys2Data?.PaymentCurrencyName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Purchasing Organization</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.PurchasingOrganizationName ? kys2Data?.PurchasingOrganizationName : '-'} </span>
                        </Col>
                        <>
                            <Col md={6} className="hl-heading-details">
                                <span className="hl-title-details">Supplier GST Classification</span>
                            </Col>
                            <Col md={6} className="pr-6 hl-descmain-details">
                                <span className="hl-desc-details"> {kys2Data?.SupplierClassificationName ? kys2Data?.SupplierClassificationName : '-'}</span>
                            </Col>
                        </>
                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Account Group</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.AccountGroupName ? kys2Data?.AccountGroupName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Reconciliation Account</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.ReconciliationAccount ? kys2Data?.ReconciliationAccount : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">SOC Code</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.SOCCode ? kys2Data?.SOCCode : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Payment Method</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.PaymentMethodName ? kys2Data?.PaymentMethodName : '-'} </span>
                        </Col>
                        <Col md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Have you met the owner director of the company?</span>
                        </Col>
                        <Col md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(kys2Data?.IsMetOwnerOrDirector) && (
                                        <>
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                <span className="ps-3">{showYesOrNoLabel(kys2Data?.IsMetOwnerOrDirector)}</span>
                                            </p>
                                        </>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span> {(!kys2Data?.IsMetOwnerOrDirector && kys2Data?.OwnerOfCompanyRemark) ? kys2Data?.OwnerOfCompanyRemark : '-'}</span>
                                </p>
                            </span>
                        </Col>
                        <Col md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Address proof document copy attached</span>
                        </Col>
                        <Col md={6} className="hl-descmain-details pr-0">
                            <span className="hl-desc-details d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(kys2Data?.AddressProof) && (
                                        <>
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                <span className="ps-3">{showYesOrNoLabel(kys2Data?.AddressProof)}</span>
                                            </p>
                                        </>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span>{(!kys2Data?.AddressProof && kys2Data?.AddressProofRemark) ? kys2Data?.AddressProofRemark : '-'}</span>
                                    <span className='ps-3 text-center d-flex justify-content-end pr-5'>{(kys2Data?.AddressProof && !!kys2Data?.AddressProofDocumentUrl) && (
                                        <Button
                                            className="hl-upload-btn hl-mb-0"
                                            title="Download"
                                            onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.AddressProofDocumentUrl) }}
                                            disabled={false}
                                        >
                                            <div className="download mr-0"></div>
                                        </Button>
                                    )}
                                    </span>
                                </p>
                            </span>
                        </Col>

                        {
                            viewDataFromSupplier?.SupplierOrigin == 1 && (
                                <>
                                    <Col md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">Copy of PAN card attached</span>
                                    </Col>
                                    <Col md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(kys2Data?.PANCard) && (
                                                    <>
                                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                            <span className="ps-3">{showYesOrNoLabel(kys2Data?.PANCard)}</span>
                                                        </p>
                                                    </>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                                <span>
                                                    {(!kys2Data?.PANCard && kys2Data?.PANCardRemark) ? kys2Data?.PANCardRemark : '-'}
                                                </span>
                                                <span>
                                                    {(kys2Data?.PANCard) ? kys2Data?.PanCardNumber : '-'}
                                                </span>
                                                <span className='ps-3 text-center d-flex justify-content-end pr-5'>
                                                    {(kys2Data?.PANCard && !!kys2Data?.PANCardDocumentUrl) && (
                                                        <Button
                                                            className="hl-upload-btn hl-mb-0"
                                                            title="Download"
                                                            onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.PANCardDocumentUrl) }}
                                                            disabled={false}
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </Button>
                                                    )}
                                                </span>
                                            </p>
                                        </span>
                                    </Col>

                                    <Col md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">MSME Supplier</span>
                                    </Col>
                                    <Col md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(kys2Data?.IsMSMESupplier) && (
                                                    <>
                                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                            <span className="ps-3">{showYesOrNoLabel(kys2Data?.IsMSMESupplier)}</span>
                                                        </p>
                                                    </>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                                <span>
                                                    {(!kys2Data?.IsMSMESupplier && kys2Data?.MSMESupplierRemark) ? kys2Data.MSMESupplierRemark : '-'}
                                                </span>
                                                
                                            </p>
                                        </span>
                                    </Col>

                                    <Col md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">MSME certificate copy attached</span>
                                    </Col>
                                    <Col md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(kys2Data?.MSMECertificate) && (
                                                    <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                        <span className="ps-3">{showYesOrNoLabel(kys2Data?.MSMECertificate)}</span>
                                                    </p>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                                <span>
                                                    {(!kys2Data?.MSMECertificate && kys2Data?.MSMECertificateRemark) ? kys2Data?.MSMECertificateRemark : '-'}
                                                </span>
                                                <span>
                                                    {(kys2Data?.MSMECertificate) ? kys2Data?.MSMECertificateNumber : '-'}
                                                </span>
                                                <span className='ps-3 text-center d-flex justify-content-end pr-5'>

                                                    {(kys2Data?.MSMECertificate && !!kys2Data?.MSMECertificateDocumentUrl) && (
                                                        <Button
                                                            className="hl-upload-btn hl-mb-0"
                                                            title="Download"
                                                            onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.MSMECertificateDocumentUrl) }}
                                                            disabled={false}
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </Button>
                                                    )}
                                                </span>
                                            </p>
                                        </span>
                                    </Col>
                                </>
                            )
                        }
                        <Col md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">
                                {
                                    viewDataFromSupplier?.SupplierOrigin === 1 && (
                                        <>
                                            Cancelled cheque
                                        </>
                                    )
                                }
                                {
                                    viewDataFromSupplier?.SupplierOrigin === 2 && (
                                        <>
                                            Duly signed & stamp letter of declaration/PI for bank detail
                                        </>
                                    )
                                }
                            </span>
                        </Col>
                        <Col md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(kys2Data?.CancelledCheque) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(kys2Data?.CancelledCheque)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span>
                                        {(!kys2Data?.CancelledCheque && kys2Data?.CancelledChequeRemark) ? kys2Data?.CancelledChequeRemark : '-'}
                                    </span>
                                    <span className='ps-3 text-center d-flex justify-content-end pr-5'>
                                        {(kys2Data?.CancelledCheque && !!kys2Data?.CancelledChequeDocumentUrl) && (
                                            <Button
                                                className="hl-upload-btn hl-mb-0"
                                                title="Download"
                                                onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.CancelledChequeDocumentUrl) }}
                                                disabled={false}
                                            >
                                                <div className="download mr-0"></div>
                                            </Button>
                                        )}
                                    </span>
                                </p>
                            </span>
                        </Col>
                        {
                            viewDataFromSupplier?.SupplierOrigin == 1 && (
                                <>
                                    <Col md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">Copy of GSTIN attached, and GST compliance status</span>
                                    </Col>
                                    <Col md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(kys2Data?.GSTINCertificate) && (
                                                    <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                        <span className="ps-3">{showYesOrNoLabel(kys2Data?.GSTINCertificate)}</span>
                                                    </p>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                                <span>
                                                    {(!kys2Data?.GSTINCertificate && kys2Data?.GSTINCertificateRemark) ? kys2Data?.GSTINCertificateRemark : '-'}
                                                </span>
                                                <span>
                                                    {(kys2Data?.GSTINCertificate) ? kys2Data?.GSTINCertificateNumber : '-'}
                                                </span>
                                                <span className='ps-3 text-center d-flex justify-content-end pr-5'>
                                                    {(kys2Data?.GSTINCertificate && !!kys2Data?.GSTINCertificateDocumentUrl) && (
                                                        <Button
                                                            className="hl-upload-btn hl-mb-0"
                                                            title="Download"
                                                            onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.GSTINCertificateDocumentUrl) }}
                                                            disabled={false}
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </Button>
                                                    )}
                                                </span>
                                            </p>
                                        </span>
                                    </Col>

                                    <Col md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">Copy of PF/ESI registration number</span>
                                    </Col>
                                    <Col md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(kys2Data?.PF_ESIRegistration) && (
                                                    <>
                                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                            <span className="ps-3">{showYesOrNoLabel(kys2Data?.PF_ESIRegistration)}</span>
                                                        </p>
                                                    </>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                <span className="ps-3 text-center">
                                                    {kys2Data?.PFRegistrationNumber ? kys2Data?.PFRegistrationNumber : "-"}
                                                </span>
                                                <span className="ps-3 text-center d-flex justify-content-end pr-5">{(kys2Data?.PF_ESIRegistration && !!kys2Data?.PFRegistrationDocumentUrl) && (
                                                    <Button
                                                        className="hl-upload-btn hl-mb-0"
                                                        title="Download"
                                                        onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.PFRegistrationDocumentUrl) }}
                                                        disabled={false}
                                                    >
                                                        <div className="download mr-0"></div>
                                                    </Button>
                                                )}</span>

                                            </p>
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                <span className="ps-3 text-center">
                                                    {kys2Data?.ESIRegistrationNumber ? kys2Data?.ESIRegistrationNumber : "-"}
                                                </span>
                                                <span className="ps-3 text-center d-flex justify-content-end pr-5">
                                                    {(kys2Data?.PF_ESIRegistration && !!kys2Data?.ESIRegistrationDocumentUrl) && (
                                                        <Button
                                                            className="hl-upload-btn hl-mb-0"
                                                            title="Download"
                                                            onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.ESIRegistrationDocumentUrl) }}
                                                            disabled={false}
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </Button>
                                                    )}</span>
                                            </p>
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 pl-4`}>
                                                {(!kys2Data?.PF_ESIRegistration && kys2Data?.PF_ESIRegistrationRemark) ? kys2Data?.PF_ESIRegistrationRemark : '-'}
                                            </p>
                                        </span>
                                    </Col>
                                </>
                            )
                        }

                        <Col md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Cost sheet attached</span>
                        </Col>
                        <Col md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(kys2Data?.CostSheet) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(kys2Data?.CostSheet)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span>
                                        {(!kys2Data?.CostSheet && kys2Data?.CostSheetRemark) ? kys2Data?.CostSheetRemark : '-'}
                                    </span>
                                    <span className='ps-3 text-center d-flex justify-content-end pr-5'>
                                        {(kys2Data?.CostSheet && !!kys2Data?.CostSheetDocumentUrl) && (
                                            <Button
                                                className="hl-upload-btn hl-mb-0"
                                                title="Download"
                                                onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.CostSheetDocumentUrl) }}
                                                disabled={false}
                                            >
                                                <div className="download mr-0"></div>
                                            </Button>
                                        )}
                                    </span>
                                </p>
                            </span>
                        </Col>

                        <Col md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Code of Conduct</span>
                        </Col>
                        <Col md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(kys2Data?.CodeOfConduct) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(kys2Data?.CodeOfConduct)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span>
                                        {(!kys2Data?.CodeOfConduct && kys2Data?.CodeOfConductRemark) ? kys2Data?.CodeOfConductRemark : '-'}
                                    </span>
                                    <span className='ps-3 text-center d-flex justify-content-end pr-5'>
                                        {(kys2Data?.CodeOfConduct && !!kys2Data?.CodeOfConductDocumentUrl) && (
                                            <Button
                                                className="hl-upload-btn hl-mb-0"
                                                title="Download"
                                                onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.CodeOfConductDocumentUrl) }}
                                                disabled={false}
                                            >
                                                <div className="download mr-0"></div>
                                            </Button>
                                        )}
                                    </span>
                                </p>
                            </span>
                        </Col>
                        {
                            kys2Data?.IsPSARequired && (
                                <>
                                    <Col md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">Product sourcing agreement/Job work Agreement</span>
                                    </Col>
                                    <Col md={6} className="pr-6 hl-descmain-details">
                                        <span className="hl-desc-details justify-content-between pr-0 d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(kys2Data?.ProductSourcing) && (
                                                    <>
                                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                            <span className="ps-3">{showYesOrNoLabel(kys2Data?.ProductSourcing)}</span>
                                                        </p>
                                                    </>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                                {(!kys2Data?.ProductSourcing && kys2Data?.ProductSourcingRemark) ? kys2Data?.ProductSourcingRemark : '-'}
                                                {(kys2Data?.ProductSourcing && !!kys2Data?.ProductSourcingDocumentUrl) && (
                                                    <Button
                                                        className="hl-upload-btn hl-mb-0"
                                                        title="Download"
                                                        onClick={(e) => { triggerFileDownloadByUrl(e, kys2Data?.ProductSourcingDocumentUrl) }}
                                                        disabled={false}
                                                    >
                                                        <div className="download mr-0"></div>
                                                    </Button>
                                                )}
                                            </p>
                                        </span>
                                    </Col>
                                </>
                            )
                        }
                    </Row>
                </Col>


                <Col sm={24} md={6}>
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <h3 className="sd-common-heading">
                                Party has been introduced in Havells Group by whom
                            </h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Name</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.Name ? kys2Data?.Name : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Department Name</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.DepartmentName ? kys2Data?.DepartmentName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Contact Person Name(Supplier)</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.ContactPersonName ? kys2Data?.ContactPersonName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Origin of Sources</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.Origin_of_SourcesName ? kys2Data?.Origin_of_SourcesName : '-'} </span>
                        </Col>

                        <Col md={6} className="hl-heading-details">
                            <span className="hl-title-details">Remark</span>
                        </Col>
                        <Col md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details"> {kys2Data?.Remark ? kys2Data?.Remark : '-'} </span>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {/* <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer hl-btm-footer mt-3">
                        <div className="col-sm-12 text-right bluefooter-butn">
                            <button type="submit" className="submit-button save-btn mr5">
                                <div className="save-icon"></div> Save
                            </button>
                        </div>
                    </Row> */}
        </div>
    )
}

export default KysTwoView;
